// extracted by mini-css-extract-plugin
export default {"container":"SettingsPage_container__QNjdc"};